import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged, filter, map, Observable, shareReplay, switchMap } from "rxjs";
import { ClienteResponse } from "../../dtos/core/cliente/ClienteResponse";
import { ClienteService } from "../../services/core/cliente/cliente.service";
import { ExternalAuthService } from "../../services/auth/external-auth/external-auth.service";
import { ExternalToken } from "../../dtos/core/auth/ExternalToken";

@Injectable({ providedIn: 'root' })
export class ClienteContextService {

  readonly cliente$: Observable<ClienteResponse>;

  constructor(
    private clienteService: ClienteService,
    private externalAuthService: ExternalAuthService
  ) {
    this.cliente$ = this.externalAuthService.currentCliente.pipe(
      filter((token): token is ExternalToken => !!token),

      distinctUntilChanged(
        (a, b) => a.clienteId === b.clienteId
      ),

      switchMap(() =>
        this.clienteService.getClienteLogged().pipe(
          map(res => res.data)
        )
      ),

      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  getCliente(): Observable<ClienteResponse> {
    return this.cliente$;
  }
}
